export default function () {
    return {
        index: '',
        type: 'STATIC_BLOCK',
        title: 'Staffbase News',
        thumbnailUrl: null,
        content: {
            columnNum: 1,
            backgroundColor: '#ffffff',
            wrapperBackgroundColor: '#ffffff',
            paddingTop: 20,
            paddingBottom: 20,
            structureLocked: false,
            columns: [
                {
                    columnIdx: '',
                    size: '1',
                    columnItems: [],
                },
            ],
        },
    };
}
